import type { Dot } from '@cc/api-types';
import { cx } from '../lib/cx';

/** teal = the assistant is on it, gold = waiting, coral = needs Seth, blue = confirmed, grey = done. */
export const DOT_COLOR: Record<Dot, string> = {
  teal: '#00AF87',
  gold: '#E2C341',
  coral: '#FF6F61',
  blue: '#0B1D26',
  grey: '#9FB3BB',
};

export function StatusDot({ dot, size = 8, className }: { dot: Dot; size?: number; className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={cx('inline-block shrink-0 rounded-full', className)}
      style={{ width: size, height: size, background: DOT_COLOR[dot] }}
    />
  );
}
